import {
  GET_USER_COURSES_PAGE,
  GET_USER_COURSES,
} from './constants'

export function getUserCoursesPage ({ offset, limit, userId, mine, activityTypeId }) {
  return (dispatch, getState, { mapmy }) => {
    return dispatch({
      type: GET_USER_COURSES_PAGE,
      payload: mapmy.getCourses({
        limit: limit,
        offset: offset,
        user_id: userId,
        activity_type_id: activityTypeId,
        mine: mine,
      }).then(({ data }) => {
        return {
          count: data.pagination.total,
          results: data.courses,
        }
      }),
    })
  }
}

export function getUserCourses (userId, limit, mine = true) {
  const params = {
    user_id: userId,
    mine: mine,
    limit: limit,
    activity_type_id: '16',
  }
  return (dispatch, getState, { mapmy }) => {
    return dispatch({
      type: GET_USER_COURSES,
      payload: mapmy.getCourses(params),
    })
  }
}
